module.exports = __webpack_public_path__ + "media/images/icons/icn_005-54646bc46061bcc519520fad9347b21d.svg";